import React from "react"
import { CardHeader } from "reactstrap"

const CardHeaderComponent = ({
  title,
  subtitle,
  alignHeader = "center",
  closeButton = false,
  toggleCloseButton = undefined,
}) => {
  const CloseButton = () => {
    return (
      <span
        onClick={toggleCloseButton}
        style={{ fontSize: "32px" }}
        type="button"
      >
        <i className="mdi mdi-close text-light"></i>
      </span>
    )
  }

  return (
    <div className={`text-${alignHeader}`}>
      <CardHeader
        style={{
          backgroundColor: "#ff8b6d",
          borderTopLeftRadius: "0.3rem",
          borderTopRightRadius: "0.3rem",
          color: "#ffffff"
        }}
      >
        {(title || closeButton) && (
          <h3>
            <span style={{ fontStyle: "italic" }}>{title}</span>
            <span style={{ float: "right", fontWeight: "24px" }}>
              {closeButton && CloseButton()}
            </span>
          </h3>
        )}
        <h2 className="text-uppercase fw-bolder">{subtitle}</h2>
      </CardHeader>
    </div>
  )
}

export default CardHeaderComponent
